import { apiRequest } from '../http/httpClient';

export const customerApi = {
  getMe(token) {
    return apiRequest('/api/customers/me', { token });
  },

  updateMe(payload, token) {
    return apiRequest('/api/customers/me', { method: 'PUT', body: payload, token });
  },

  changeMyPassword(payload, token) {
    return apiRequest('/api/customers/me/password', { method: 'PUT', body: payload, token });
  },

  listCustomers(token) {
    return apiRequest('/api/customers', { token });
  },

  changeRole(customerId, role, token) {
    return apiRequest(`/api/customers/${customerId}/role`, { method: 'PATCH', body: { role }, token });
  },
};
